import { Injectable } from '@angular/core';
import { SentryErrorHandler } from '@sentry/angular';
import smartlookClient from 'smartlook-client';

interface ErrorWithMessage {
	message?: string;
	stack?: string;
	name?: string;
}

@Injectable()
export class ErrorHandlerService extends SentryErrorHandler {
	constructor() {
		super({ showDialog: false });
	}

	handleError(error: ErrorWithMessage): void {
		// Do not send Smartlook errors to Sentry
		if (this.isSmartlookError(error)) {
			this.handleErrorInSmartlook(error);
			return;
		}

		super.handleError(error);
		this.handleChunkLoadError(error);
		console.error(error);
	}

	private isSmartlookError(error: ErrorWithMessage): boolean {
		return (
			error?.message?.includes('smartlook') || error?.stack?.includes('smartlook') || error?.name?.includes('smartlook')
		);
	}

	handleErrorInSmartlook(error: ErrorWithMessage): void {
		if (smartlookClient.initialized()) {
			try {
				smartlookClient.error(JSON.stringify(error));
			} catch (smartlookError) {
				// Silently handle Smartlook errors
				console.warn('Smartlook error handling failed:', smartlookError);
			}
		}
	}

	handleChunkLoadError(error: ErrorWithMessage): void {
		const chunkFailedMessage = /Loading chunk [\d]+ failed/;
		if (error?.message && chunkFailedMessage.test(error.message)) {
			const urlParams = new URLSearchParams(window.location.search);
			if (urlParams.has('reload')) return;
			urlParams.set('reload', 'true');
			window.location.search = urlParams.toString();
			window.location.reload();
		}
	}
}
